import React from "react";
import { parseEncasing } from "../../utils/utils";


const EncasingParser = ({ encasing, categoryName }) => {

  return <span>
    { parseEncasing(encasing, categoryName) }
  </span>
};

export default EncasingParser;